import React from 'react';

import NotFoundPage from '../pages/404';
import Layout from '../_layout/layout';
import SEO from '../_layout/seo';

import { parseUrlCertificationPage } from '../_helpers';
import BreadCrumbs from '../_components/shares/breadcrumbs';
import CertificationPageCover from '../_components/certificationpage/cover';
import CertificationCompanies from '../_components/certificationpage/companies';

// import SidebarExternalArticlesLatest from '../_components/shares/sidebar-external-articles-latest';
import JournalFeaturedPosts from '../_components/shares/journal-featured-posts';
import HomeBenefits from '../_components/homepage/benefits';
import SidebarAds from '../_components/shares/sidebar-ads';

const initialState = {
  breadcrumbs: [],
  seo: [],
};

class CertificationPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  async componentWillMount() {
    const routes = parseUrlCertificationPage(
      this.props.location.pathname,
      this.props.location.search
    );
    await this.setState(routes);
    await this.updateBreadCrumbsAndSeo();
  }

  async componentWillReceiveProps(nextProps) {
    const routes = parseUrlCertificationPage(
      nextProps.location.pathname,
      nextProps.location.search
    );
    await this.setState(routes);
    await this.updateBreadCrumbsAndSeo();
  }

  updateBreadCrumbsAndSeo = async () => {
    const { info } = this.state;
    if (!info.name) return;

    let bclinks = [{ name: info.title, to: `/certification/${info.id}/` }];
    let keywords = info.keywords.split(',');
    let seo = {};

    seo.title = info.title + ' | 働き方情報 Clarity（クラリティ）';
    seo.description = info.description;
    seo.keywords = keywords;
    seo.url = `/certification/${info.id}/`;

    await this.setState({ breadcrumbs: bclinks, seo: seo });
  };

  render() {
    const { url_error, info, seo, breadcrumbs } = this.state;

    if (url_error) return <NotFoundPage />;

    // we need this to build /certification/<blank> page
    if (!info.name)
      return (
        <Layout>
          <SEO />
        </Layout>
      );

    return (
      <Layout>
        <SEO
          title={seo.title && seo.title}
          description={seo.description && seo.description}
          keywords={seo.keywords && seo.keywords}
          ogp={seo.ogp && seo.ogp}
          url={seo.url}
        />

        <BreadCrumbs bclinks={breadcrumbs} />

        <CertificationPageCover
          cover={info.cover}
          icon={info.icon}
          name={info.name}
          title={info.title}
          seo_wording={info.seo_wording}
        />

        <div className="container-fluid px-0 max-1100">
          <div className="row mx-0">
            {/*  */}
            <div className="col-lg-9 col-12">
              <div className="certification-desc">
                <p>{info.name}とは？</p>
                <span>{info.description}</span>
              </div>

              {/* companies */}
              <CertificationCompanies info={info} />
            </div>
            {/*  */}
            <div className="col-lg-3 col-12 sidebar-wrapper">
              <SidebarAds />
              <JournalFeaturedPosts />
              {/* <SidebarExternalArticlesLatest /> */}
              {/* benefits list */}
              <div className="sidebar-wrapper-content">
                <div className="sidebar-wrapper-title">
                  <span className="text-green">働き方情報をみる</span>
                </div>
                <HomeBenefits />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

export default CertificationPage;
